import React, { useEffect, useState, useRef, forwardRef } from 'react';
import request from 'utils/request_ajax';
import { connect } from 'react-redux';
import {
  selectSingleAssignment,
  removeAssignment,
  updateDate,
} from 'actions/assignmentActivity/assignment_action';
import DateFormat from 'constants/date_format';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Tooltip from 'components/shared/Tooltip';
import {
  Calendar,
  Bell,
  UserX,
  CheckCircle,
  List,
  RotateCcw,
  MoreHorizontal,
} from 'react-feather';
import { Icon } from 'ui';

const AssignmentsTableRow = ({
  rowData,
  selectAssignment,
  setReminder,
  setRemindAllUsers,
  setSelectedId,
  isManuallyTextAssignmentReminders,
  metadata,
  removeAssignments,
  updateDueDate,
  setIncompleteActionModal,
  setReassignActionModal,
  hideSelect,
  hideStatus,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [progressReport, setProgressReport] = useState(null);
  const [expandReassign, setExpandReassign] = useState(false);
  const [reassignDate, setReassignDate] = useState();

  const modalRef1 = useRef(null);
  const modalRef2 = useRef(null);
  const awaitingReassignmentPage = metadata.status === 'awaiting_reassignment';

  const handleReassignClick = id => {
    if (!awaitingReassignmentPage) {
      setExpandReassign(true);
    } else {
      setSelectedId(id);
      setReassignActionModal(true);
    }
  };

  const handleClickOutside = event => {
    if (modalRef1.current && !modalRef1.current.contains(event.target)) {
      setExpanded(false);
    }
    if (modalRef2.current && !modalRef2.current.contains(event.target)) {
      setExpandReassign(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const destroyAssignment = (id, url, status) => {
    /* eslint-disable-next-line no-alert */
    if (window.confirm(t('assignments.confirm_destroy'))) {
      removeAssignments(id, url);
      if (hideSelect) window.location = metadata.lesson.lessonPath;
    }
  };

  const showProgressReport = url => {
    request.get(url).done(resp => {
      setProgressReport(resp);
      setExpanded(!expanded);
    });
  };

  const sendReminder = (id, reminderUrl, remindUrl) => {
    if (isManuallyTextAssignmentReminders) {
      request.postJSON(reminderUrl).then(resp => {
        setRemindAllUsers(resp);
        setReminder(true);
      });
    } else {
      request.postScript(remindUrl);
    }
  };

  const reassignLesson = url => {
    const data = {
      due_by: reassignDate
        ? moment(reassignDate).format(DateFormat.fixed.DB_DATE)
        : '',
      commit: 'Reassign',
    };
    request.patchJSON(url, data).then(() => {
      window.location.reload(true);
    });
  };

  const CustomInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <Tooltip position="bottom" text={t('assignments.set_due_date')}>
      <Calendar
        tabIndex={0}
        size={20}
        onClick={onClick}
        onKeyDown={e => e.key === 'Enter' && onClick()}
        ref={ref}
      >
        {value || placeholder}
      </Calendar>
    </Tooltip>
  ));

  const CustomReassignButton = forwardRef(({ onClick }, ref) => (
    <button
      onClick={onClick}
      ref={ref}
      type="button"
      className="Label Label--dueDate reassign-btn"
    >
      {reassignDate ? moment(reassignDate).format(DateFormat.SHORT) : 'Anytime'}
    </button>
  ));

  const markComplete = event => {
    if (event.key === 'Enter') {
      setSelectedId([rowData.id]);
      setIncompleteActionModal(true);
    }
  };

  const groupsDetails =
    metadata.title === 'group/everyone' ||
    metadata.title === 'group/system_generated' ||
    metadata.title === 'group/smart' ||
    metadata.title === 'group';

  return (
    <tr
      id={`assignment__${rowData.id}`}
      className={`assignment ${hideStatus ? '' : rowData.status}`}
    >
      <td className="SelecTable-select">
        <b className="tablesaw-cell-label">
          <input className="SelecTable-toggleAll" type="checkbox" />
        </b>
        <span className="tablesaw-cell-content">
          <input
            type="checkbox"
            name={`assignment_${rowData.id}`}
            id={`assignment_${rowData.id}`}
            checked={rowData?.isChecked || false}
            className="SelecTable-toggle"
            onChange={e => selectAssignment(e.target.checked, rowData.id)}
            aria-label="checkbox"
          />
        </span>
      </td>
      <td className="AssignmentsTable-status">
        <span
          className={`CompletionStatusIcon CompletionStatusIcon--${
            hideStatus ? '' : rowData.status
          }`}
        >
          {!hideStatus && rowData.status === 'completed' && (
            <Icon name="completed" aria-label="Multi-Session Icon" />
          )}
        </span>
      </td>
      {metadata.title === 'lesson' && (
        <td className="DataTable-name AssignmentsTable-assignee ">
          <b className="tablesaw-cell-label">{t('assignments.assignee')}</b>
          <span className="tablesaw-cell-content">
            <a href={rowData.urls.overview}>{rowData.assigneeName}</a>
          </span>
        </td>
      )}
      {metadata.title === 'user' && (
        <td className="DataTable-name AssignmentsTable-assignable">
          <b className="tablesaw-cell-label">{t('assignments.singular')}</b>
          <span className="tablesaw-cell-content">
            <a href={rowData.urls.overview}>
              {rowData.type === 'LearningPaths::Path' && (
                <Icon
                  aria-label="Multi-Session Icon"
                  name="path"
                  className="mr-4"
                />
              )}
              {rowData.lessonName}
            </a>
          </span>
        </td>
      )}
      {groupsDetails && (
        <>
          <td className="DataTable-name AssignmentsTable-assignee ">
            <b className="tablesaw-cell-label">{t('assignments.assignee')}</b>
            <span className="tablesaw-cell-content">
              <a href={rowData.urls.overview}>{rowData.assigneeName}</a>
            </span>
          </td>
          <td className="DataTable-name AssignmentsTable-assignable">
            <b className="tablesaw-cell-label">{t('assignments.singular')}</b>
            <span className="tablesaw-cell-content">
              <a href={rowData.urls.overview}>
                {rowData.type === 'LearningPaths::Path' && (
                  <MoreHorizontal
                    className="JourneyBuilderTopbar-icon-more"
                    size={16}
                  />
                )}
                {rowData.lessonName}
              </a>
            </span>
          </td>
        </>
      )}
      {metadata.title === 'learning_paths/path' && (
        <td className="DataTable-name AssignmentsTable-assignee ">
          <b className="tablesaw-cell-label">{t('assignments.assignee')}</b>
          <span className="tablesaw-cell-content">
            <a href={rowData.urls.overview}>{rowData.assigneeName}</a>
          </span>
        </td>
      )}
      <td className="AssignmentsTable-dueDate">
        <b className="tablesaw-cell-label">{t('assignments.due')}</b>
        <span className="tablesaw-cell-content">
          {rowData.dueBy &&
            moment
              .parseZone(rowData.dueBy)
              .format(DateFormat.MONTH_DAY_YEAR_SHORT)}
        </span>
      </td>
      <td className="AssignmentsTable-startedAt">
        <b className="tablesaw-cell-label">{t('progress.started')}</b>
        <span className="tablesaw-cell-content">
          {rowData.startedAt &&
            moment(rowData.startedAt).format(DateFormat.SHORT_AT_TIME)}
        </span>
      </td>
      <td className="AssignmentsTable-completedAt">
        <b className="tablesaw-cell-label">
          {t('assignments.completed.label')}
        </b>
        <span className="tablesaw-cell-content">
          {rowData.completedAt &&
            moment(rowData.completedAt).format(DateFormat.SHORT_AT_TIME)}
        </span>
      </td>
      <td className="AssignmentsTable-attempts">
        <b className="tablesaw-cell-label">{t('assignments.attempts')}</b>
        <span className="tablesaw-cell-content">{rowData.timeTaken}</span>
      </td>
      <td className="AssignmentsTable-score">
        <b className="tablesaw-cell-label">{t('gradebook.export.score')}</b>
        <span className="tablesaw-cell-content">
          {rowData.score ? (rowData.score * 100).toFixed(2) + '%' : ''}
        </span>
      </td>
      <td
        className={`${
          hideSelect ? 'DataTable-actions' : 'DataTable-actionsRow'
        }`}
      >
        <b className="tablesaw-cell-label" />
        <span className="tablesaw-cell-content">
          <ul
            className={`${hideSelect ? 'InlineActions' : 'InlineActionsRow'}`}
          >
            {rowData.type === 'LearningPaths::Path' && (
              <li className="InlineActionsRow-actionIcons">
                <span
                  id={`path_progress_assignment_${rowData.id}`}
                  className={`has_popover path_lesson_progress ${
                    expanded && 'expanded'
                  }`}
                  data-behavior="expandable collapse_on_outside_click"
                >
                  <Tooltip
                    position="bottom"
                    text={t('assignments.paths.progress_report')}
                  >
                    <List
                      tabIndex={0}
                      size={20}
                      onClick={() =>
                        showProgressReport(rowData.urls.progressReport)
                      }
                      onKeyDown={e =>
                        e.key === 'Enter' &&
                        showProgressReport(rowData.urls.progressReport)
                      }
                    />
                  </Tooltip>
                  <span
                    ref={modalRef1}
                    className="popover left expandable_content"
                  >
                    <div className="arrow" />
                    <div className="popover-content">
                      <h4 className="popover-title">
                        {t('assignments.paths.progress_report')}
                      </h4>
                      <ul>
                        {progressReport &&
                          progressReport.map(report => (
                            <li key={report.lesson.id}>
                              <span
                                className={`CompletionStatusIcon ${report.completion_status_class}`}
                              >
                                {report['completed?'] && (
                                  <Icon
                                    name="completed"
                                    small
                                    aria-label="Multi-Session Icon"
                                  />
                                )}
                              </span>
                              <span className="ml-4">
                                {report.lesson_title}
                              </span>
                              <span>{report.score_written_out}</span>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </span>
                </span>
              </li>
            )}
            {(rowData.status !== 'completed' || awaitingReassignmentPage) &&
              rowData.permissions.canUpdate && (
                <li className="InlineActionsRow-actionIcons">
                  <DatePicker
                    onChange={date => updateDueDate(date, rowData.id)}
                    popperPlacement="left"
                    showPopperArrow
                    minDate={moment(Date.now())}
                    customInput={<CustomInput />}
                    aria-label={t('assignments.set_due_date')}
                  >
                    <button
                      name="button"
                      type="submit"
                      className="ButtonLink SelecTable-actionButton SelecTable-dueDateSelect"
                      onClick={() => updateDueDate(null, rowData.id)}
                    >
                      {t('assignments.no_due_date')}
                    </button>
                  </DatePicker>
                </li>
              )}
            {rowData.status !== 'completed' && rowData.permissions.canRemind && (
              <li className="InlineActionsRow-actionIcons assignment_reminder">
                <Tooltip position="bottom" text={t('assignments.remind')}>
                  <Bell
                    tabIndex={0}
                    size={20}
                    onClick={() =>
                      sendReminder(
                        rowData.id,
                        rowData.urls.sendReminder,
                        rowData.urls.remind,
                      )
                    }
                    onKeyDown={e =>
                      e.key === 'Enter' &&
                      sendReminder(
                        rowData.id,
                        rowData.urls.sendReminder,
                        rowData.urls.remind,
                      )
                    }
                    aria-label={t('assignments.remind')}
                  />
                </Tooltip>
              </li>
            )}
            {rowData.status !== 'completed' &&
              rowData.type === 'Lesson' &&
              rowData.permissions.canMarkComplete && (
                <li className="InlineActionsRow-actionIcons">
                  <Tooltip
                    position="bottom"
                    text={t('assignments.mark_complete.title')}
                  >
                    <CheckCircle
                      tabIndex={0}
                      name={t('assignments.mark_complete.title')}
                      size={20}
                      onClick={() => {
                        setSelectedId([rowData.id]);
                        setIncompleteActionModal(true);
                      }}
                      onKeyDown={e => markComplete(e)}
                    />
                  </Tooltip>
                </li>
              )}
            {rowData.status === 'completed' && (
              <li className="InlineActionsRow-actionIcons">
                <span className="has_popover">
                  <Tooltip position="bottom" text={t('assignments.reassign')}>
                    <RotateCcw
                      tabIndex={0}
                      size={20}
                      onClick={() => handleReassignClick(rowData.id)}
                      onKeyDown={e => e.key === 'Enter' && setExpanded(true)}
                      aria-label={t('assignments.reassign')}
                    />
                  </Tooltip>
                  {expandReassign && (
                    <span ref={modalRef2} className="popover left d-b">
                      <div className="arrow" />
                      <div className="popover-content">
                        <span>{t('assignments.make_due.lesson')}</span>
                        <DatePicker
                          dateFormat="MM/DD/YYYY"
                          onChange={date => setReassignDate(date)}
                          minDate={moment(Date.now())}
                          popperPlacement="bottom"
                          customInput={<CustomReassignButton />}
                        />
                        <button
                          className="actions btn"
                          type="button"
                          tabIndex="0"
                          onClick={() => reassignLesson(rowData.urls.reassign)}
                        >
                          {t('assignments.reassign')}
                        </button>
                      </div>
                    </span>
                  )}
                </span>
              </li>
            )}
            {rowData.permissions.canDestroy && rowData.status !== 'pending' && (
              <li className="InlineActionsRow-actionIcons">
                <Tooltip position="bottom" text={t('assignments.destroy')}>
                  <UserX
                    tabIndex={0}
                    size={20}
                    onClick={() => {
                      destroyAssignment(
                        rowData.id,
                        rowData.urls.unassign,
                        rowData.status,
                      );
                    }}
                    onKeyDown={e =>
                      e.key === 'Enter' &&
                      destroyAssignment(
                        rowData.id,
                        rowData.urls.unassign,
                        rowData.status,
                      )
                    }
                    aria-label={t('assignments.destroy')}
                  />
                </Tooltip>
              </li>
            )}
          </ul>
        </span>
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  metadata: state.meta.metadata,
});

const mapDispatchToProps = dispatch => ({
  selectAssignment(checked, id) {
    dispatch(selectSingleAssignment(checked, id));
  },
  removeAssignments(id, url) {
    dispatch(removeAssignment(id, url));
  },
  updateDueDate(date, id) {
    dispatch(updateDate(date, id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignmentsTableRow);
